const judete = [
    { name: "Alba", POD: 59402040000 },
    { name: "Bihor", POD: 59404020000  },
    { name: "Bistrita-Nasaud", POD: 59404050000  },
    { name: "Braila", POD: 59403020000  },
    { name: "Brasov", POD: 59403020000  },
    { name: "Buzau", POD: 59403030000  },
    { name: "Cluj", POD: 59404010000  },
    { name: "Covasna", POD: 59402060000  },
    { name: "Dambovita", POD: 59403060000  },
    { name: "Galati", POD: 59403050000  },
    { name: "Harghita", POD: 59402050000  },
    { name: "Maramures", POD: 59404030000  },
    { name: "Mures", POD: 59402030000  },
    { name: "Prahova", POD: 59403010000  },
    { name: "Salaj", POD: 59404060000  },
    { name: "Satu Mare", POD: 59404040000  },
    { name: "Sibiu", POD: 59402020000  },
    { name: "Vrancea", POD: 59403040000  },
  ];
  
  export default judete;
  